import { z } from "zod";

/**
 * Synchronizace kontaktů HCA → Google Contacts.
 *
 * Vstupy jsou záměrně minimální — jaké kontakty se synchronizují, určuje
 * server z role a `obchodnikId`, klient si scope vybrat nemůže.
 */

/** Uživatelský vypínač synchronizace (propojení zůstává zachované). */
export const googleSyncSetEnabledSchema = z.object({
  enabled: z.boolean(),
});

export type GoogleSyncSetEnabledInput = z.infer<typeof googleSyncSetEnabledSchema>;

/**
 * Callback z Google OAuth. `code` a `state` chodí jako query parametry na
 * Hono routu, takže je validujeme stejným schématem jako tRPC vstupy.
 * `error` posílá Google, když uživatel souhlas odmítne.
 */
export const googleSyncCallbackSchema = z.object({
  code: z.string().min(1).max(2048).optional(),
  state: z.string().min(1).max(2048).optional(),
  error: z.string().max(255).optional(),
});

export type GoogleSyncCallbackInput = z.infer<typeof googleSyncCallbackSchema>;

/**
 * Uložení OAuth klíčů (Client ID + Secret) z administrace do `app_settings`.
 *
 * `clientSecret` je volitelný: když už je secret uložený, admin může změnit
 * jen Client ID a secret nechat beze změny. Prázdný string z formuláře se
 * mapuje na `undefined` (stejný význam jako `optionalString` v env.ts) —
 * server pak podrží stávající uloženou hodnotu.
 */
export const setGoogleSyncConfigSchema = z.object({
  clientId: z
    .string()
    .trim()
    .min(1, "Vyplňte Client ID")
    .max(200, "Client ID může mít nejvýše 200 znaků"),
  clientSecret: z
    .string()
    .trim()
    .max(200, "Client Secret může mít nejvýše 200 znaků")
    .optional()
    .transform((v) => (v ? v : undefined)),
});

export type SetGoogleSyncConfigInput = z.infer<typeof setGoogleSyncConfigSchema>;
